import { makeStyles } from "tss-react/mui"
import { Grid, Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../../../../dialogs/StandardDialog"
import { StandardButton } from "../../../../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "0 4rem 1.5rem",
        gap: "2rem",
    },
    button: {
        borderRadius: "0.5rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
    },
    cancelButton: {
        color: theme.palette.tailwind.slate[800],
    },
    cancelButtonLink: {
        color: theme.palette.tailwind.red[800],
        textDecoration: "underline",
    },
    successButton: {
        background: theme.palette.tailwind.slate[800],
        borderColor: theme.palette.tailwind.slate[300],
    },
}))

type PriceMismatchDialogProps = Readonly<{
    open: boolean
    handleCloseDialog: () => void
    handleCloseMainDialog: () => void
    handleChangePrices: () => void
    isRefundOrder: boolean
}>

export function PriceMismatchDialog({
    handleCloseDialog,
    handleCloseMainDialog,
    handleChangePrices,
    isRefundOrder,
}: PriceMismatchDialogProps) {
    const { classes, cx } = useStyles()

    return (
        <LocalizedStrict
            id="create-order-order-summary-meeting-services-product-price-mismatch-dialog"
            attrs={{ dialogTitle: true }}
        >
            <StandardDialog
                open
                onClose={() => {}}
                maxWidthProp="sm"
                hideCloseIcon
                slotProps={{
                    root: {
                        sx: {
                            zIndex: 9999,
                        },
                    },
                }}
                subtitle={
                    <LocalizedStrict id="create-order-order-summary-meeting-services-product-price-mismatch-dialog-message">
                        <Typography variant="body1">
                            Some products in your order have changed in price. If you continue to update the order, all
                            items will be updated to their current price."
                        </Typography>
                    </LocalizedStrict>
                }
                dialogTitle="Prices for your products have changed"
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                    wrap="nowrap"
                    className={classes.container}
                >
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        alignItems="center"
                        justifyContent="center"
                        gap="1rem"
                    >
                        {isRefundOrder ? (
                            <LocalizedStrict id="create-order-order-summary-meeting-services-product-price-mismatch-dialog-cancel-button">
                                <StandardButton
                                    color="grey"
                                    variant="outlined"
                                    onClick={() => {
                                        handleCloseDialog()
                                    }}
                                    size="medium"
                                    className={cx(classes.cancelButton)}
                                    updateDefaultClasses={classes.button}
                                >
                                    Don't update prices
                                </StandardButton>
                            </LocalizedStrict>
                        ) : (
                            <LocalizedStrict id="create-order-no-products-dialog-button-label-cancel">
                                <StandardButton
                                    color="grey"
                                    variant="outlined"
                                    onClick={() => {
                                        handleCloseMainDialog()
                                    }}
                                    size="medium"
                                    className={cx(classes.cancelButton)}
                                    updateDefaultClasses={classes.button}
                                >
                                    Go to home
                                </StandardButton>
                            </LocalizedStrict>
                        )}
                        {handleChangePrices && (
                            <LocalizedStrict id="create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button">
                                <StandardButton
                                    onClick={() => {
                                        handleChangePrices()
                                    }}
                                    size="medium"
                                    className={cx(classes.successButton)}
                                    updateDefaultClasses={classes.button}
                                >
                                    Update
                                </StandardButton>
                            </LocalizedStrict>
                        )}
                    </Grid>
                    {isRefundOrder && (
                        <Stack>
                            <LocalizedStrict id="create-order-no-products-dialog-button-label-cancel">
                                <StandardButton
                                    color="error"
                                    variant="text"
                                    onClick={() => {
                                        handleCloseMainDialog()
                                    }}
                                    size="medium"
                                    className={cx(classes.cancelButtonLink)}
                                    updateDefaultClasses={classes.button}
                                >
                                    Go to home
                                </StandardButton>
                            </LocalizedStrict>
                        </Stack>
                    )}
                </Grid>
            </StandardDialog>
        </LocalizedStrict>
    )
}
